export default __webpack_public_path__ + "static/media/Pistol_8.c3d6901d.png";